import React from "react";
import { Text, FrameIcon } from "../../../services/visualLibraryService";
import { i18n } from "../../../services/i18nService";
import { config } from "../../../config/config";
import { getAppState } from "../../../state";
import { ListInfoSettingsStyled, BuildItemStyled, ItemStyled, Spacer } from "../styles/Styled";
import { ProfileWrapper, HeaderTextStyled } from "../../Settings/styles/Styled";

const BuildInfo = () => {
  // This build info is a placeholder that gets updated in Jenkins once the app is built. This means locally the version
  // won't be displayed in the screen but only when the app is being served from a given environment (prod, stg, dev...)
  const buildInfo = getAppState().buildInfo;
  buildInfo["Public Version"] = config.get().sdk.publicVersion;
  return (
    buildInfo && (
      <ListInfoSettingsStyled>
        {Object.keys(buildInfo).map(item => (
          <BuildItemStyled key={item}>
            <ItemStyled>
              {item}: {buildInfo[item]}
            </ItemStyled>
          </BuildItemStyled>
        ))}
      </ListInfoSettingsStyled>
    )
  );
};

export const Help = () => {
  return (
    <>
      <ProfileWrapper>
        <FrameIcon name="help" alignSelf="start" />
        <HeaderTextStyled rank="1" text={i18n.get(`pages.settings.help.title`)} size="large" />
      </ProfileWrapper>
      <Text text={i18n.get(`pages.settings.help.paragraph1`)} size="small" type="greyLight" />
      <Text text={i18n.get(`pages.settings.help.paragraph2`)} size="small" type="greyLight" />
      <BuildInfo />
    </>
  );
};